import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';
import './coordinators.scss';
import { Constants, ImageConstants, AccessRights } from '../../constants/constants';
import { getImageSource } from '../../utility/image-source';
import AddNewCoordinator from './add-new-coordinator/add-new-coordinator'
import CWConfirm from '../common/cw-confirmation-modal/cw-confirmation-modal'
import SessionCache from '../routes/session-cache';
import DeleteTeacher from '../teachers/delete-teacher/delete-teacher'

import SchoolApi from '../../apis/school'
import AssignCoordinator from './assign-coordinator/assign-coordinator';
class Coordinators extends Component {

    state = {
        adminUsers: [],
        events: []
    }

    accessRights = SessionCache.getAllowedModule()
    user = SessionCache.getUser()

    componentDidMount() {
        let userInfo = SessionCache.getUser()
        this.setState({ userInfo })
        this.getEvents()
    }

    getStaffs(payload = {}) {
        payload.types = "in/COORDINATOR"
        SchoolApi.getStaffs(payload)
            .then(response => {
                this.setState({ adminUsers: response?.response || [] })
            }).catch(err => {
            })

    }

    getEvents(payload = {}) {
        let user = SessionCache.getUser()
        const eventParticipated = []
        if(user.schoolInfo?.eventParticipated?.length) {
            user.schoolInfo.eventParticipated.map(e => {
                eventParticipated.push(e.eventId);
                return e;
            })
        }
        payload.schoolName = user.schoolInfo?.name
        payload.schoolLocality = user.schoolInfo?.address?.branch
        payload.eventParticipated = eventParticipated;
        payload.upcoming = true;
        SchoolApi.getEventsList(payload)
            .then(response => {
                
                this.setState({ events: response || [] }, _ => {
                    this.getStaffs()
                })
            }).catch(err => {
            })

    }

    showAddCoordinatorModal = (item, type) => {
        this.setState({ showAddCoordinatorModal: true, selectedUser: item, mode: type })
    }

    hideAddCoordinatorModal = () => {
        this.setState({ showAddCoordinatorModal: false }, _ => {
            if(this.assignCoordinatorRef) this.assignCoordinatorRef.getStaffs()
        })
        if(this.tooltip){ 
            this.tooltip.tooltipRef = null
            this.tooltip.hideTooltip()
        }
        ReactTooltip.hide()
    }

    showAssignCoordinatorModal = (item, mode) => {
        this.setState({ showAssignCoordinatorModal: true, selectedEvent: item })
    }

    hideAssignCoordinatorModal = () => {
        this.setState({ showAssignCoordinatorModal: false }, _ => {
            this.getStaffs()
        })
        if(this.tooltip){ 
            this.tooltip.tooltipRef = null
            this.tooltip.hideTooltip()
        }
        ReactTooltip.hide()
    }

    hideConfirmModal = () => {
        this.setState({ emailSendConfirmModal: false, showDeleteModal: false})
        if(this.tooltip){ 
            this.tooltip.tooltipRef = null
            this.tooltip.hideTooltip()
        }
        ReactTooltip.hide()
    }

    removeUser = (isRejected) => {
        let payload = { _id: this.state.selectedEvent?._id }
        if(isRejected){
            payload.status = {type: "REJECTED", displayType: "Rejected"}
            payload.rejectReason = this.state.rejectReason
            payload.rejectDetails = this.state.rejectDetails
        }
        SchoolApi.deleteStaff(payload)
            .then(response => {
                this.getStaffs()
                this.hideConfirmModal()
            }).catch(err => {
                console.log(err)
            })
    }

    onSave = () => {
        this.hideAddCoordinatorModal()
        this.getEvents()
    }

    sendEmail = () => {
        let payload = {
            userId: this.state.inviteUser?._id
        }
        SchoolApi.sendInvite(payload)
            .then(response => {
                this.getStaffs()
                this.hideConfirmModal()
            }).catch(err => {
                console.log(err)
            })
    }

    onClickEmail = (item) => {
        this.setState({ emailSendConfirmModal: true, deleteMessage: "Are you sure want send invitation", inviteUser: item })
    }

    onDeleteSuccess = () => {

        this.getStaffs()

        this.hideConfirmModal();
    }

    renderCoordinators(eventId, type) {
        const {adminUsers} = this.state
        if(!adminUsers.length) return "---"
        const coordinators = []
        adminUsers.map(u => {
            let content = ""
            if(u.events && u.events.includes(eventId)) {
                if(type === "name"){
                    content = u
                }
                if(type === "mobileNumber") content = u.mobileNumber 
                if(type === "email") content = u.email
            }
            if(content) coordinators.push(content)
        })
        if(type === "name"){
            if(coordinators.length) { 
                return coordinators.map((c, index)=> (
                    <div key={index} className='name-text cursor-pointer' onClick={_ => this.showAddCoordinatorModal(c, "EDIT")}>
                        {c.firstName} {c.lastName ? c.lastName : ""}
                    </div>
                ))
            }
            return "---"
        } else {
            return coordinators.length > 0 ? coordinators.join(", ") : "---"
        }
    }

    render() {
        const {adminUsers} = this.state
        return (
            <div className='coordinators'>

                <div>

                    <div className='row'>

                        <div className='col text-right'>

                            <div className='row' onMouseEnter={ReactTooltip.rebuild}>
                                <div className='col'>
                                    {
                                        this.accessRights[AccessRights.ADD_CONTACT] ? <span >
                                            <button className='cw-btn-md d-inline-block cw-btn-primary mr-2' onClick={() => this.showAddCoordinatorModal({}, 'CREATE')} data-tip={"Add Coordinator"}>
                                                ADD COORDINATOR
                                            </button>
                                        </span> : ""
                                    }
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

                {this.state.events && this.state.events.length ?
                    <div id="table-scoll" className="table-responsive mt-5">
                        <table className="table cw-table mb-0 align-items-center">
                            <thead>
                                <tr>
                                    <th className='th-left-radius'>Event</th>
                                    <th className=''>Coordinator(s)</th>
                                    <th className=''>Contact</th>
                                    <th className=''>Email</th>
                                    <th className='th-right-radius'></th>
                                </tr>
                            </thead>
                            <tbody className="bg-white">
                                {
                                    this.state.events?.map((item, index) => (

                                        <tr key={item._id + 1} className={`mt-4`} onMouseEnter={ReactTooltip.rebuild}>
                                            <td className='py-5'>
                                                <div className='name-text'>
                                                    {item.title}
                                                </div>
                                            </td>
                                            <td className='py-5'>
                                                {this.renderCoordinators(item._id, 'name') === "---" ?
                                                    <span className='no-coordinator'>No Coordinator assigned</span> :
                                                    <span>{this.renderCoordinators(item._id, 'name')}</span>
                                                }
                                                {
                                                    this.accessRights[AccessRights.ADD_CONTACT] &&
                                                    <img className="add-icon cursor-pointer" onClick={_ => this.showAssignCoordinatorModal(item)} src={getImageSource(ImageConstants.ADD)} />
                                                }
                                            </td>
                                            <td className='py-5'>{this.renderCoordinators(item._id, 'mobileNumber')}</td>
                                            <td className='py-5'>{this.renderCoordinators(item._id, 'email')}</td>
                                            <td className='py-5'>
                                                {
                                                    this.accessRights[AccessRights.EDIT_CONTACT] ?
                                                        <span className="px-2">
                                                            <img className="add-contact cursor-pointer" onClick={() => this.showAssignCoordinatorModal(item, "EDIT")} src={getImageSource(ImageConstants.EDIT)} data-tip={"Edit Coordinator"} />
                                                        </span> : ""
                                                }
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div >
                    :

                    <div className='no-record-container'>
                        <div className='text-center'><img className='no-record-image' src={getImageSource(ImageConstants.NO_RECORDS)} /></div>
                        <div className='text-center pt-2'><text >No Events participated currently!</text></div>
                    </div>

                }
                {this.state.showAddCoordinatorModal && <AddNewCoordinator show={this.state.showAddCoordinatorModal} selectedUser={this.state.selectedUser} mode={this.state.mode} onSave={this.onSave} onClose={this.hideAddCoordinatorModal} size='lg' />}
                {this.state.showDeleteModal && <DeleteTeacher close={this.hideConfirmModal} event={this.state.selectedEvent} onOk={this.onDeleteSuccess.bind(this)} />}
                {this.state.emailSendConfirmModal && <CWConfirm modal={this.state.emailSendConfirmModal} close={this.hideConfirmModal} message={this.state.deleteMessage} onOk={this.sendEmail.bind(this)} />}
                {this.state.showAssignCoordinatorModal && <AssignCoordinator ref={el => this.assignCoordinatorRef = el} coordinators={adminUsers} showAddCoordinator={this.showAddCoordinatorModal} selectedEvent={this.state.selectedEvent} show={this.state.showAssignCoordinatorModal} onClose={this.hideAssignCoordinatorModal} delegate={this.props} />}
                <ReactTooltip ref={el => this.tooltip = el} multiline={true} place='bottom' type='dark' effect='solid' event="mouseover mouseenter" eventOff="mouseleave mouseout scroll mousewheel blur" />
            </div>

        )
    }

}

export default Coordinators;